export default "__VITE_ASSET__2539e3db__"